module.exports = __webpack_public_path__ + "static/media/KUDOS TITAN 707 SPEAKERS.ceada300.png";